import { connect } from 'react-redux'
import CreateOrganisation from './CreateOrganisation'
import * as actions from '../../redux/organisations'

const mapStateToProps = (state) => ({
  error: state.organisations.error,
  mainTabValue: state.organisations.mainTabValue,
  whiteLabelApps: state.organisations.whiteLabelApps,
});

export default connect(mapStateToProps, actions)(CreateOrganisation)
